<template>
  <div v-show="isShow.isPOShow" class="pageOne">
    <div class="canvasContainer" id="canvasContainer"></div>
    <div class="tutorial shine"></div>
    <div class="controller" ref="controllerEle">
      <div class="tab">
        <div class="btnCamera" @click="genPoster"></div>
        <div class="tutAddNew" :class="isFirstAddPerson ? 'slideInOut' : 'hideIt'"></div>
        <div class="tabItem" :class="isDSelected ? 'tabSelected' : ''" @click="onSelectD">
          <img src="./img/couplet.png" class="img5" alt="">
        </div>
        <div class="tabItem" :class="isASelected ? 'tabSelected' : ''" @click="onSelectA">
          <img src="./img/human.png" class="img2" alt="">
        </div>
        <div class="tabItem" :class="isBSelected ? 'tabSelected' : ''" @click="onSelectB">
          <img src="./img/child.png" class="img3" alt="">
        </div>
        <div class="tabItem" :class="isCSelected ? 'tabSelected' : ''" @click="onSelectC">
          <img src="./img/pet.png" class="img4" alt="">
        </div>
      </div>
      <div class="contents" :class="isFold ? 'contentsFold' : 'contentsNotFold'">
        <div class="contentCoupletWrapper" :class="isDSelected ? '' : 'hideContent'">
          <div class="content-couplet">
            <div class="cpItem" @click="addCoup('coup1', $event)">
              <img src="./img/coup1.png" :class="isFold ? 'hide' : ''" class="coup" alt="">
              <div class="tutAgain1 tutAgain" :class="!isFirstAddCoup && isFirstAddCoup1 ? 'slideInOut' : 'hideIt'"></div>
            </div>
            <div class="cpItem" @click="addCoup('coup2', $event)">
              <img src="./img/coup2.png" :class="isFold ? 'hide' : ''" class="coup" alt="">
              <div class="tutAgain2 tutAgain" :class="!isFirstAddCoup && isFirstAddCoup2 ? 'slideInOut' : 'hideIt'"></div>
            </div>
            <div class="cpItem" @click="addCoup('coup3', $event)">
              <img src="./img/coup3.png" :class="isFold ? 'hide' : ''" class="coup" alt="">
              <div class="tutAgain3 tutAgain" :class="!isFirstAddCoup && isFirstAddCoup3 ? 'slideInOut' : 'hideIt'"></div>
            </div>
            <div class="cpItem" @click="addCoup('coup4', $event)">
              <img src="./img/coup4.png" :class="isFold ? 'hide' : ''" class="coup" alt="">
              <div class="tutAgain4" :class="!isFirstAddCoup && isFirstAddCoup4 ? 'slideInOut' : 'hideIt'"></div>
            </div>
          </div>
        </div>
        <div class="contentPetWrapper" :class="isCSelected ? '' : 'hideContent'">
          <div class="content-pet">
            <div class="petItem" @click="addEle('pet1', $event)">
              <img src="./img/pet1.png" :class="isFold ? 'hide' : ''" class="pet1" alt="">
            </div>
            <div class="petItem" @click="addEle('pet2', $event)">
              <img src="./img/pet2.png" :class="isFold ? 'hide' : ''" class="pet2" alt="">
            </div>
            <div class="petItem" @click="addEle('pet3', $event)">
              <img src="./img/pet3.png" :class="isFold ? 'hide' : ''" class="pet3" alt="">
            </div>
            <div class="petItem" @click="addEle('pet4', $event)">
              <img src="./img/pet4.png" :class="isFold ? 'hide' : ''" class="pet4" alt="">
            </div>
            <div class="petItem" @click="addEle('pet5', $event)">
              <img src="./img/pet5.png" :class="isFold ? 'hide' : ''" class="pet5" alt="">
            </div>
            <div class="petItem" @click="addEle('pet6', $event)">
              <img src="./img/pet6.png" :class="isFold ? 'hide' : ''" class="pet6" alt="">
            </div>
            <div class="petItem" @click="addEle('pet7', $event)">
              <img src="./img/pet7.png" :class="isFold ? 'hide' : ''" class="pet7" alt="">
            </div>
            <div class="petItem" @click="addEle('pet8', $event)">
              <img src="./img/pet8.png" :class="isFold ? 'hide' : ''" class="pet8" alt="">
            </div>
            <div class="petItem" @click="addEle('pet9', $event)">
              <img src="./img/pet9.png" :class="isFold ? 'hide' : ''" class="pet9" alt="">
            </div>
            <div class="petItem" @click="addEle('pet10', $event)">
              <img src="./img/pet10.png" :class="isFold ? 'hide' : ''" class="pet10" alt="">
            </div>
          </div>
        </div>
        <div class="contentChildrenWrapper" :class="isBSelected ? '' : 'hideContent'">
          <div class="content-children">
            <div class="chItem" @click="addEle('child1', $event)">
              <img src="./img/child1.png" :class="isFold ? 'hide' : ''" class="child1" alt="">
            </div>
            <div class="chItem" @click="addEle('child2', $event)">
              <img src="./img/child2.png" :class="isFold ? 'hide' : ''" class="child2" alt="">
            </div>
            <div class="chItem" @click="addEle('child3', $event)">
              <img src="./img/child3.png" :class="isFold ? 'hide' : ''" class="child3" alt="">
            </div>
            <div class="chItem" @click="addEle('child4', $event)">
              <img src="./img/child4.png" :class="isFold ? 'hide' : ''" class="child4" alt="">
            </div>
          </div>
        </div>
        <div class="contentHumanWrapper" :class="isASelected ? '' : 'hideContent'">
          <div class="content-human" v-if="!isDetail">
            <div class="chItem" @click="onSelectHuman('youngM', $event)">
              <img src="./img/h1.png" :class="isFold ? 'hide' : ''" class="h1" alt="">
            </div>
            <div class="chItem" @click="onSelectHuman('youngF', $event)">
              <img src="./img/h2.png" :class="isFold ? 'hide' : ''" class="h2" alt="">
            </div>
            <div class="chItem" @click="onSelectHuman('parentM', $event)">
              <img src="./img/h3.png" :class="isFold ? 'hide' : ''" class="h3" alt="">
            </div>
            <div class="chItem" @click="onSelectHuman('parentF', $event)">
              <img src="./img/h4.png" :class="isFold ? 'hide' : ''" class="h4" alt="">
            </div>
            <div class="chItem" @click="onSelectHuman('grandM', $event)">
              <img src="./img/h5.png" :class="isFold ? 'hide' : ''" class="h5" alt="">
            </div>
            <div class="chItem" @click="onSelectHuman('grandF', $event)">
              <img src="./img/h6.png" :class="isFold ? 'hide' : ''" class="h6" alt="">
            </div>
          </div>
          <div class="content-detail" v-else>
            <div class="leftNav">
              <div class="head" :class="isHead ? '' : 'hcSelected'" @click="onSelectInnerNav('head', $event)">
                <img src="./img/h-thumb1.png" :class="isFold ? 'hide' : ''" alt="">
              </div>
              <div class="clothes" :class="isHead ? 'hcSelected' : ''" @click="onSelectInnerNav('clothes', $event)">
                <img src="./img/h-thumb2.png" :class="isFold ? 'hide' : ''" alt="">
              </div>
            </div>
            <div class="rightDetail">
              <div class="itemWrapper" v-if="isHead">
                <!-- 男性选项 head -->
                <div class="detailItemWrapper" v-if="isYMSelected">
                  <div class="detailItem" @click="addHead('youngM1', $event)">
                    <img src="./img/young-m1h.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="detailItem" @click="addHead('youngM2', $event)">
                    <img src="./img/young-m2h.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="detailItem" @click="addHead('youngM3', $event)">
                    <img src="./img/young-m3h.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="detailItem" @click="addHead('youngM4', $event)">
                    <img src="./img/young-m4h.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="detailItem" @click="addHead('youngM5', $event)">
                    <img src="./img/young-m5h.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="detailItem" @click="addHead('youngM6', $event)">
                    <img src="./img/young-m6h.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                </div>
                <!-- 女性选项 head-->
                <div class="detailItemWrapper" v-if="isYFSelected">
                  <div class="detailItem" @click="addHead('youngF1', $event)">
                    <img src="./img/yfh-thumb1.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="detailItem" @click="addHead('youngF2', $event)">
                    <img src="./img/yfh-thumb2.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="detailItem" @click="addHead('youngF3', $event)">
                    <img src="./img/yfh-thumb3.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="detailItem" @click="addHead('youngF4', $event)">
                    <img src="./img/yfh-thumb4.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="detailItem" @click="addHead('youngF5', $event)">
                    <img src="./img/yfh-thumb5.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="detailItem" @click="addHead('youngF6', $event)">
                    <img src="./img/yfh-thumb6.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                </div>
                <!-- parent 男 head -->
                <div class="detailItemWrapper" v-if="isPMSelected">
                  <div class="halfDetailItem" @click="addHead('parentM1', $event)">
                    <img src="./img/pmh-thumb1.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="halfDetailItem" @click="addHead('parentM2', $event)">
                    <img src="./img/pmh-thumb2.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                </div>
                <!-- parent 女 head -->
                <div class="detailItemWrapper" v-if="isPFSelected">
                  <div class="halfDetailItem" @click="addHead('parentF1', $event)">
                    <img src="./img/pfh-thumb1.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="halfDetailItem" @click="addHead('parentF2', $event)">
                    <img src="./img/pfh-thumb2.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                </div>
                <!-- grand 男 head -->
                <div class="detailItemWrapper" v-if="isGMSelected">
                  <div class="halfDetailItem" @click="addHead('grandM1', $event)">
                    <img src="./img/gmh-thumb1.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="halfDetailItem" @click="addHead('grandM2', $event)">
                    <img src="./img/gmh-thumb2.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                </div>
                <!-- grand 女 head -->
                <div class="detailItemWrapper" v-if="isGFSelected">
                  <div class="halfDetailItem" @click="addHead('grandF1', $event)">
                    <img src="./img/gfh-thumb1.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="halfDetailItem" @click="addHead('grandF2', $event)">
                    <img src="./img/gfh-thumb1.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                </div>
              </div>
              <div class="itemWrapper" v-else>
                <!-- 男性选项 clothes -->
                <div class="detailItemWrapper" v-if="isYMSelected">
                  <div class="detailItem" @click="addClothes('youngM1', $event)">
                    <img src="./img/ymc-thumb1.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="detailItem" @click="addClothes('youngM2', $event)">
                    <img src="./img/ymc-thumb2.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="detailItem" @click="addClothes('youngM3', $event)">
                    <img src="./img/ymc-thumb3.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="detailItem" @click="addClothes('youngM4', $event)">
                    <img src="./img/ymc-thumb4.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="detailItem" @click="addClothes('youngM5', $event)">
                    <img src="./img/ymc-thumb5.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="detailItem" @click="addClothes('youngM6', $event)">
                    <img src="./img/ymc-thumb6.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                </div>
                <!-- 女性选项 clothes -->
                <div class="detailItemWrapper" v-if="isYFSelected">
                  <div class="detailItem" @click="addClothes('youngF1', $event)">
                    <img src="./img/yfc-thumb1.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="detailItem" @click="addClothes('youngF2', $event)">
                    <img src="./img/yfc-thumb2.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="detailItem" @click="addClothes('youngF3', $event)">
                    <img src="./img/yfc-thumb3.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="detailItem" @click="addClothes('youngF4', $event)">
                    <img src="./img/yfc-thumb4.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="detailItem" @click="addClothes('youngF5', $event)">
                    <img src="./img/yfc-thumb5.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="detailItem" @click="addClothes('youngF6', $event)">
                    <img src="./img/yfc-thumb6.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                </div>
                <!-- parent 男性选项 clothes -->
                <div class="detailItemWrapper" v-if="isPMSelected">
                  <div class="halfDetailItem" @click="addClothes('parentM1', $event)">
                    <img src="./img/pmc-thumb1.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="halfDetailItem" @click="addClothes('parentM2', $event)">
                    <img src="./img/pmc-thumb2.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                </div>
                <!-- parent 女性选项 clothes -->
                <div class="detailItemWrapper" v-if="isPFSelected">
                  <div class="halfDetailItem" @click="addClothes('parentF1', $event)">
                    <img src="./img/pfc-thumb1.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="halfDetailItem" @click="addClothes('parentF2', $event)">
                    <img src="./img/pfc-thumb2.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                </div>
                <!-- grand 男性选项 clothes -->
                <div class="detailItemWrapper" v-if="isGMSelected">
                  <div class="halfDetailItem" @click="addClothes('grandM1', $event)">
                    <img src="./img/gmc-thumb1.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="halfDetailItem" @click="addClothes('grandM2', $event)">
                    <img src="./img/gmc-thumb2.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                </div>
                <!-- grand 女性选项 clothes -->
                <div class="detailItemWrapper" v-if="isGFSelected">
                  <div class="halfDetailItem" @click="addClothes('grandF1', $event)">
                    <img src="./img/gfc-thumb1.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                  <div class="halfDetailItem" @click="addClothes('grandF2', $event)">
                    <img src="./img/gfc-thumb2.png" :class="isFold ? 'hide' : ''" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as PIXI from 'pixi.js';
import { eleData } from './datafile.js';

let Application = PIXI.Application;
let Texture = PIXI.Texture;
let Sprite = PIXI.Sprite;
// let Text = PIXI.Text;

export default {
  name: 'PageTwo',
  props: {
    isShow: {
      type: Object
    }
  },
  data() {
    return {
      myEleData: eleData,
      bg: require('./img/bg.jpg'),
      btnDel: require('./img/btn-del.png'),
      btnResize: require('./img/btn-resize.png'),
      personImg: require('./img/h1.png'),
      child1Img: require('./img/child1.png'),
      child2Img: require('./img/child2.png'),
      child3Img: require('./img/child3.png'),
      child4Img: require('./img/child4.png'),
      pet1Img: require('./img/pet1.png'),
      pet2Img: require('./img/pet2.png'),
      pet3Img: require('./img/pet3.png'),
      pet4Img: require('./img/pet4.png'),
      pet5Img: require('./img/pet5.png'),
      pet6Img: require('./img/pet6.png'),
      pet7Img: require('./img/pet7.png'),
      pet8Img: require('./img/pet8.png'),
      pet9Img: require('./img/pet9.png'),
      pet10Img: require('./img/pet10.png'),
      coup11Img: require('./img/coup11.png'),
      coup12Img: require('./img/coup12.png'),
      coup13Img: require('./img/coup13.png'),
      coup14Img: require('./img/coup14.png'),
      coup21Img: require('./img/coup21.png'),
      coup22Img: require('./img/coup22.png'),
      coup23Img: require('./img/coup23.png'),
      coup24Img: require('./img/coup24.png'),
      coup31Img: require('./img/coup31.png'),
      coup32Img: require('./img/coup32.png'),
      coup33Img: require('./img/coup33.png'),
      coup34Img: require('./img/coup34.png'),
      coup41Img: require('./img/coup41.png'),
      coup42Img: require('./img/coup42.png'),
      coup43Img: require('./img/coup43.png'),
      coup44Img: require('./img/coup44.png'),
      youngM1h: require('./img/young-m1h.png'),
      youngM2h: require('./img/young-m2h.png'),
      youngM3h: require('./img/young-m3h.png'),
      youngM4h: require('./img/young-m4h.png'),
      youngM5h: require('./img/young-m5h.png'),
      youngM6h: require('./img/young-m6h.png'),
      youngM1c: require('./img/young-m1c.png'),
      youngM2c: require('./img/young-m2c.png'),
      youngM3c: require('./img/young-m3c.png'),
      youngM4c: require('./img/young-m4c.png'),
      youngM5c: require('./img/young-m5c.png'),
      youngM6c: require('./img/young-m6c.png'),
      youngF1h: require('./img/young-f1h.png'),
      youngF2h: require('./img/young-f2h.png'),
      youngF3h: require('./img/young-f3h.png'),
      youngF4h: require('./img/young-f4h.png'),
      youngF5h: require('./img/young-f5h.png'),
      youngF6h: require('./img/young-f6h.png'),
      youngF1c: require('./img/young-f1c.png'),
      youngF2c: require('./img/young-f2c.png'),
      youngF3c: require('./img/young-f3c.png'),
      youngF4c: require('./img/young-f4c.png'),
      youngF5c: require('./img/young-f5c.png'),
      youngF6c: require('./img/young-f6c.png'),
      parentM1h: require('./img/parent-m1h.png'),
      parentM2h: require('./img/parent-m2h.png'),
      parentM1c: require('./img/parent-m1c.png'),
      parentM2c: require('./img/parent-m2c.png'),
      parentF1h: require('./img/parent-f1h.png'),
      parentF2h: require('./img/parent-f2h.png'),
      parentF1c: require('./img/parent-f1c.png'),
      parentF2c: require('./img/parent-f2c.png'),
      grandM1h: require('./img/grand-m1h.png'),
      grandM2h: require('./img/grand-m2h.png'),
      grandM1c: require('./img/grand-m1c.png'),
      grandM2c: require('./img/grand-m2c.png'),
      grandF1h: require('./img/grand-f1h.png'),
      grandF2h: require('./img/grand-f2h.png'),
      grandF1c: require('./img/grand-f1c.png'),
      grandF2c: require('./img/grand-f2c.png'),
      textImg: require('./img/fn-text.jpg'),
      w1Img: require('./img/w1.png'),
      w2Img: require('./img/w2.png'),
      w3Img: require('./img/w3.png'),
      w4Img: require('./img/w4.png'),
      w5Img: require('./img/w5.png'),
      isFirstAddPerson: false,
      isFirstAddCoup: false,
      isFirstAddCoup1: false,
      isFirstAddCoup2: false,
      isFirstAddCoup3: false,
      isFirstAddCoup4: false,
      coupNum: 1,
      isYMSelected: false,
      isYFSelected: false,
      isPMSelected: false,
      isPFSelected: false,
      isGMSelected: false,
      isGFSelected: false,
      isFold: false,
      isDetail: false,
      isHead: true,
      isASelected: false,
      isBSelected: false,
      isCSelected: false,
      isDSelected: true,
      targetName: null,
      startPosition: null,
      endPosition: null,
      isDragging: false,
      toBeResized: null,
      isResizingDrag: false,
      resizeScale: null,
      app: null
    }
  },
  methods: {
    showNext () {
      this.isShow.isPOShow = false
      this.isShow.isPTShow = true
    },
    onFold() {
      this.isFold = !this.isFold;
    },
    onSelectA() {
      this.isASelected = true;
      this.isBSelected = false;
      this.isCSelected = false;
      this.isDSelected = false;
      this.isDetail = false;
      this.isFold = false;
    },
    onSelectB() {
      this.isASelected = false;
      this.isBSelected = true;
      this.isCSelected = false;
      this.isDSelected = false;
      this.isFold = false;
    },
    onSelectC() {
      this.isASelected = false;
      this.isBSelected = false;
      this.isCSelected = true;
      this.isDSelected = false;
      this.isFold = false;
    },
    onSelectD() {
      this.isASelected = false;
      this.isBSelected = false;
      this.isCSelected = false;
      this.isDSelected = true;
      this.isFold = false;
    },
    onSelectHuman(msg, evt) {
      this.addPerson(msg, evt);
      this.select(msg);
    },
    onSelectASub() {
      this.isDetail = true;
      this.isASelected = true;
      this.isBSelected = false;
      this.isCSelected = false;
      this.isDSelected = false;
      // this.isFold = false;
    },
    select(msg) {
      const calMsg = msg.replace(/\d+/g, '');
      switch (calMsg) {
        case 'youngM':
          this.onSelectASub();
          this.isYMSelected = true;
          this.isYFSelected = false;
          this.isPMSelected = false;
          this.isPFSelected = false;
          this.isGMSelected = false;
          this.isGFSelected = false;
          break;
        case 'youngF':
          this.onSelectASub();
          this.isYMSelected = false;
          this.isYFSelected = true;
          this.isPMSelected = false;
          this.isPFSelected = false;
          this.isGMSelected = false;
          this.isGFSelected = false;
          break;
        case 'parentM':
          this.onSelectASub();
          this.isYMSelected = false;
          this.isYFSelected = false;
          this.isPMSelected = true;
          this.isPFSelected = false;
          this.isGMSelected = false;
          this.isGFSelected = false;
          break;
        case 'parentF':
          this.onSelectASub();
          this.isYMSelected = false;
          this.isYFSelected = false;
          this.isPMSelected = false;
          this.isPFSelected = true;
          this.isGMSelected = false;
          this.isGFSelected = false;
          break;
        case 'grandM':
          this.onSelectASub();
          this.isYMSelected = false;
          this.isYFSelected = false;
          this.isPMSelected = false;
          this.isPFSelected = false;
          this.isGMSelected = true;
          this.isGFSelected = false;
          break;
        case 'grandF':
          this.onSelectASub();
          this.isYMSelected = false;
          this.isYFSelected = false;
          this.isPMSelected = false;
          this.isPFSelected = false;
          this.isGMSelected = false;
          this.isGFSelected = true;
          break;
        default:
          return
      }
    },
    onSelectInnerNav(name = 'head', evt) {
      if (name === 'head') {
        this.isHead = true;
      } else {
        this.isHead = false;
      }
    },
    init() {
      let app = new Application({
        width: 750,
        height: 1334,
        antialias: true,
        transparent: true,
        resolution: 1
      });

      const myCanvas = document.getElementById('canvasContainer');
      myCanvas.appendChild(app.view);

      let bgImg = Texture.fromImage(this.bg);
      let bgSpr = new Sprite(bgImg);
      bgSpr.width = 750;
      bgSpr.height = 1334;
      bgSpr.position.set(0, 0);
      bgSpr.interactive = true;
      bgSpr.on('tap', () => {
        this.clearOutline();
      });

      app.stage.addChild(bgSpr);
      this.app = app;

      this.clearOutline();
    },
    genPoster() {
      this.addText();
      this.showNext();
    },
    getStageHeight() {
      let windowHeight = window.innerHeight;
      let ele = this.$refs.controllerEle;
      let controllerHeight = window.getComputedStyle(ele).height;
      let realHeight = parseInt(controllerHeight.replace(/[a-z]+/g, ''));
      return windowHeight - realHeight
    },
    setOriginalPos() {
      let random = Math.random() * 40;
      let posX = 750 / 2 + random;
      let posY = 1334 / 2 + random;
      return {
        x: posX,
        y: posY
      }
    },
    getSelectedContainer(name) {
      const curContainer = this.app.stage.getChildByName(name);
      let lastChildIndex = curContainer.children.length - 1;
      curContainer.children[lastChildIndex].visible = true;
      curContainer.children[lastChildIndex - 1].visible = true;
      curContainer.children[lastChildIndex - 2].visible = true;
      this.select(name);
      return curContainer;
    },
    clearOutline () {
      let children = this.app.stage.children;
      let modifiedChildren = children.slice(1);
      let len = modifiedChildren.length;
      for (let i = 0; i < len; i++) {
        // console.log(modifiedChildren[i].name);
        if (modifiedChildren[i].name !== 'coupSpr') {
          let lastChildIndex = modifiedChildren[i].children.length - 1;
          modifiedChildren[i].children[lastChildIndex].visible = false;
          modifiedChildren[i].children[lastChildIndex - 1].visible = false;
          modifiedChildren[i].children[lastChildIndex - 2].visible = false;
        }
      }
      this.isDetail = false;
    },
    addController(sprContainer, sprWidth, sprHeight) {
      // 添加叉号按钮
      let crossImg = Texture.fromImage(this.btnDel);
      let crossSpr = new Sprite(crossImg);
      crossSpr.width = 50;
      crossSpr.height = 50;
      crossSpr.anchor.set(.5, .5);
      crossSpr.position.set(- sprWidth / 2, sprHeight / 2);
      crossSpr.interactive = true;
      crossSpr.name = 'crossBtn';

      // 添加缩放按钮
      let resizeTexture = Texture.fromImage(this.btnResize);
      let resizeSpr = new Sprite(resizeTexture);
      resizeSpr.width = 50;
      resizeSpr.height = 50;
      resizeSpr.anchor.set(.5, .5);
      resizeSpr.position.set(sprWidth / 2, - sprHeight / 2);
      resizeSpr.interactive = true;
      resizeSpr.name = 'resizeBtn';

      // 添加隐藏操作
      crossSpr.on('tap', () => {
        sprContainer.visible = false;
      });

      // 添加缩放操作
      resizeSpr.on('touchstart', (evt) => {
        if (evt.target.name === 'resizeBtn') {
          this.toBeResized = evt.target.parent;
          this.isResizingDrag = true;
          this.resizeScale = this.toBeResized.scale.x;

          this.startPosition = {
            x: evt.data.global.x,
            y: evt.data.global.y
          }
        }
      });

      resizeSpr.on('touchmove', (evt) => {
        if (this.isResizingDrag) {
          let newPosition = {
            x: evt.data.global.x,
            y: evt.data.global.y
          }
          let movedLength = newPosition.x - this.startPosition.x;
          this.startPosition.x = newPosition.x;

          if (movedLength < 0) {
            this.resizeScale -= 0.01;
            if (this.resizeScale < .4) {
              this.resizeScale = .4;
            }
          } else if (movedLength > 0) {
            this.resizeScale += 0.01;
            if (this.resizeScale > 2) {
              this.resizeScale = 2;
            }
          }
          this.toBeResized.scale.set(this.resizeScale, this.resizeScale);
        }
      });

      resizeSpr.on('touchendoutside', () => {
        this.isResizingDrag = false;
      });

      resizeSpr.on('touchend', () => {
        this.isResizingDrag = false;
      });

      // 添加容器的移动操作
      sprContainer.on('touchstart', (evt) => {
        if (!this.isResizingDrag) {
          this.targetName = evt.target.name;
          if (this.targetName !== 'crossBtn') {
            this.clearOutline();
            let curContainer = this.getSelectedContainer(this.targetName);
            if (curContainer !== undefined) {
              let len = this.app.stage.children.length - 1;
              this.app.stage.setChildIndex(curContainer, len);
            }
            this.isDragging = true;
          }
        }
      });

      sprContainer.on('touchmove', (evt) => {
        const stageHeight = this.getStageHeight() * 2;
        if (this.isDragging) {
          let posX = evt.data.global.x;
          let posY = evt.data.global.y;
          const curContainer = this.getSelectedContainer(this.targetName);
          // console.log(curContainer);
          const targetHeight = curContainer.height;
          const targetWidth = curContainer.width;
          const leftZone = targetWidth / 2;
          const upZone = targetHeight / 2;
          // X 坐标
          if (posX < leftZone) {
            curContainer.x = leftZone;
          } else if (posX >= leftZone && posX <= (750 - leftZone)) {
            curContainer.x = posX;
          } else {
            curContainer.x = 750 - leftZone;
          }
          // Y 坐标
          if (posY < upZone) {
            curContainer.y = upZone;
          } else if (posY >= upZone && posY <= (stageHeight - targetHeight / 2)) {
            curContainer.y = posY;
          } else {
            curContainer.y = stageHeight - targetHeight / 2;
          }
        }
      });

      sprContainer.on('touchend', () => {
        this.isDragging = false;
      });

      // 为精灵添加轮廓线
      let borderline = new PIXI.Graphics();
      borderline.lineStyle(1, 0xaaaaaa);
      borderline.drawRoundedRect(- sprWidth / 2 - 10, - sprHeight / 2 - 10, sprWidth + 20, sprHeight + 20, 10);
      borderline.endFill();

      sprContainer.addChild(borderline);
      sprContainer.addChild(resizeSpr);
      sprContainer.addChild(crossSpr);
    },
    addHead(name = 'youngM1', evt) {
      let gotName = name.slice(0, name.length - 1);
      let headName = name + 'h';
      let clothesName = name + 'c';
      const {w: headW, h: headH} = this.myEleData[headName];
      const {w: cloW, h: cloH} = this.myEleData[clothesName];

      let curContainer = this.app.stage.getChildByName(this.targetName);
      let curHead = curContainer.getChildAt(1);

      curContainer.removeChild(curHead);
      const headTexture = Texture.fromImage(this[`${headName}`]);
      const headSpr = new Sprite(headTexture);
      headSpr.width = headW;
      headSpr.height = headH;
      headSpr.anchor.set(.5, .5);
      headSpr.position.set(0, - cloH / 2 - 10);
      headSpr.name = headName;

      curContainer.addChildAt(headSpr, 1);
    },
    addClothes(name = 'youngM1', evt) {
      let gotName = name.slice(0, name.length - 1);
      let headName = name + 'h';
      let clothesName = name + 'c';
      const {w: headW, h: headH} = this.myEleData[headName];
      const {w: cloW, h: cloH} = this.myEleData[clothesName];

      let curContainer = this.app.stage.getChildByName(this.targetName);
      let curClothes = curContainer.getChildAt(0);

      curContainer.removeChild(curClothes);
      const clothesTexture = Texture.fromImage(this[`${clothesName}`]);
      const clothesSpr = new Sprite(clothesTexture);
      clothesSpr.width = cloW;
      clothesSpr.height = cloH;
      clothesSpr.anchor.set(.5, .5);
      clothesSpr.position.set(0, 0);
      clothesSpr.name = clothesName;

      curContainer.addChildAt(clothesSpr, 0);
    },
    addPerson(name = 'youngM', evt) {
      this.isFirstAddPerson = true;
      this.clearOutline();
      let givenName = name + Math.floor(Math.random() * 1000);
      let gotName = name + '1';
      let headName = gotName + 'h';
      let clothesName = gotName + 'c';
      this.targetName = givenName;

      const originPos = this.setOriginalPos();
      const {w: headW, h: headH} = this.myEleData[headName];
      const {w: cloW, h: cloH} = this.myEleData[clothesName];
      const container = new PIXI.Container();
      container.x = originPos.x;
      container.y = originPos.y;
      container.interactive = true;
      container.name = givenName;

      const clothesTexture = Texture.fromImage(this[`${clothesName}`]);
      const clothesSpr = new Sprite(clothesTexture);
      clothesSpr.width = cloW;
      clothesSpr.height = cloH;
      clothesSpr.anchor.set(.5, .5);
      clothesSpr.name = clothesName;

      const headTexture = Texture.fromImage(this[`${headName}`]);
      const headSpr = new Sprite(headTexture);
      headSpr.width = headW;
      headSpr.height = headH;
      headSpr.anchor.set(.5, .5);
      headSpr.position.set(0, - cloH / 2 - 10);
      headSpr.name = headName;

      container.addChild(clothesSpr);
      container.addChild(headSpr);
      this.addController(container, container.width, container.height + 50);
      this.app.stage.addChild(container);
    },
    addEle(name = 'pet1', evt) {
      this.clearOutline();
      let givenName = name + Math.floor(Math.random() * 1000);
      const originPos = this.setOriginalPos();
      const {w, h} = this.myEleData[name];
      const container = new PIXI.Container();
      container.x = originPos.x;
      container.y = originPos.y;
      container.interactive = true;
      container.name = givenName;
      this.targetName = givenName;

      const eleTexture = Texture.fromImage(this[`${name}Img`]);
      const eleSpr = new Sprite(eleTexture);
      eleSpr.width = w;
      eleSpr.height = h;
      eleSpr.anchor.set(.5, .5);
      eleSpr.name = name.slice(0, name.length - 1) + 'Spr';

      container.addChild(eleSpr);
      this.addController(container, w, h);
      this.app.stage.addChild(container);
    },
    addCoup(name = 'coup1', evt) {
      let num = name.slice(-1);
      this[`isFirstAddCoup${num}`] = true;
      setTimeout(() => {
        this.isFirstAddCoup = true;
      }, 3400);

      this.clearOutline();
      let children = this.app.stage.children;
      let modifiedChildren = children.slice(1);
      let len = modifiedChildren.length;

      for (let i = 0; i < len; i++) {
        if (modifiedChildren[i].name === 'coupSpr') {
          this.app.stage.removeChild(modifiedChildren[i]);
        }
      }

      if (this.coupNum > 4) {
        this.coupNum = 1;
      }
      const {w, h} = this.myEleData[`${name}${this.coupNum}`];

      const eleTexture = Texture.fromImage(this[`${name}${this.coupNum}Img`]);
      const eleSpr = new Sprite(eleTexture);
      eleSpr.width = w;
      eleSpr.height = h;
      eleSpr.anchor.set(.5, 0);
      eleSpr.name = name.slice(0, name.length - 1) + 'Spr';
      eleSpr.position.set(375, 40);
      eleSpr.visible = true;
      this.app.stage.addChild(eleSpr);

      this.coupNum += 1;
    },
    addText() {
      let stageHeight = this.getStageHeight();
      let tempHeight = stageHeight * 2 + 230;
      let fnHeight = tempHeight >= 1334 ? 1334 : tempHeight;
      let randNum = Math.floor(Math.random() * 5) + 1;
      this.clearOutline();

      const textTexture = Texture.fromImage(this.textImg);
      const textSpr = new Sprite(textTexture);
      textSpr.width = 750;
      textSpr.height = 230;
      textSpr.anchor.set(0, 1);
      textSpr.position.set(0, fnHeight);

      this.$emit('sendFnImgHeight', fnHeight);

      const genW = this[`w${randNum}Img`] || this.w1Img;
      const wordTexture = Texture.fromImage(genW);
      const wordSpr = new Sprite(wordTexture);
      wordSpr.width = 437;
      wordSpr.height = 105;
      wordSpr.anchor.set(.5, .5);
      wordSpr.position.set(426, -130);

      textSpr.addChild(wordSpr);

      this.app.stage.addChild(textSpr);

      setTimeout(() => {
        this.mergedSrc = this.app.renderer.plugins.extract.base64(this.app.stage);
      }, 400);
      setTimeout(() => {
        this.$emit('sendImg', this.mergedSrc);
      }, 600)
    }
  },
  mounted() {
      this.init();
  },
  watch: {

  }
}
</script>

<style lang="less" scoped>
.pageOne {
  height: 100%;
  background-size: cover;
  background-image: url(./img/bg.jpg);
  background-repeat: no-repeat;
  .canvasContainer {
    width: 100%;
  }
  .tutorial {
    position: absolute;
    bottom: 2.5rem /* 40/16 */;
    left: 2.5rem /* 40/16 */;
    width: 1.625rem /* 26/16 */;
    height: 1.375rem /* 22/16 */;
    background-image: url('./img/tutorial-hand.png');
    background-size: cover;
    background-repeat: no-repeat;
    z-index: 5;
  }
  .controller {
    position: absolute;
    bottom: 0;
    width: 100%;
    .tab {
      position: relative;
      display: flex;
      justify-content: space-between;
      height: 2.1875rem /* 35/16 */;
      background-color: #ffffff;
      .btnCamera {
        position: absolute;
        width: 2.5rem /* 40/16 */;
        height: 3.3125rem /* 53/16 */;
        right: 1.25rem /* 20/16 */;
        bottom: 3.125rem /* 50/16 */;
        background-image: url('./img/btn-camera.png');
        background-size: cover;
        background-repeat: no-repeat;
      }
      .tutAddNew {
        position: absolute;
        left: 10%;
        bottom: 2.25rem /* 36/16 */;
        width: 11.9375rem /* 191/16 */;
        height: 3.4375rem /* 55/16 */;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: url('./img/tut-addNew.png');
      }
      .tabSelected {
        background-color: #ededed;
      }
      .tabArrow {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: .625rem /* 10/16 */ 0;
        .arrowDesc {
          font-size: .625rem /* 10/16 */;
          letter-spacing: 2px;
          color: #7c7c7b;
        }
        .img1 {
          width: 2.0625rem /* 33/16 */;
          height: 1.0625rem /* 17/16 */;
        }
      }
      .tabItem {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all .4s ease;
        .img2 {
          width: 2.75*.6rem /* 44/16 */;
          height: 2.5625*.6rem  /* 41/16 */;
        }
        .img3 {
          width: 2.3125*.6rem /* 37/16 */;
          height: 2.5*.6rem /* 40/16 */;
        }
        .img4 {
          width: 2*.6rem /* 32/16 */;
          height: 2.1875*.6rem /* 35/16 */;
        }
        .img5 {
          width: 2.8125*.6rem /* 45/16 */;
          height: 2.4375*.6rem /* 39/16 */;
        }
      }
    }
    .contentsFold {
      height: 0;
    }
    .contentsNotFold {
      height: 9.75*.6rem /* 156/16 */;
    }
    .reverse {
      transform-origin: center;
      transform: rotate(180deg);
    }
    .contents {
      background-color: #ededed;
      transition: all .4s ease;
      .contentChildrenWrapper {
        height: 100%;
      }
      .contentHumanWrapper {
        height: 100%;
      }
      .contentCoupletWrapper {
        height: 100%;
      }
      .contentPetWrapper {
        height: 100%;
      }
      .content-pet {
        display: flex;
        height: 100%;
        flex-wrap: wrap;
        .petItem {
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 20%;
          .hide {
            display: none;
            transition: all .4s ease;
          }
          .pet1 {
            width: 6.4375/2*.74rem /* 103/16 */;
            height: 6.8125/2*.74rem /* 109/16 */;
            &:active{
              transform: translateY(-.375rem /* 6/16 */);
            }
          }
          .pet2 {
            width: 7.0625/2*.74rem /* 113/16 */;
            height: 6.8125/2*.74rem /* 109/16 */;
            &:active{
              transform: translateY(-.375rem /* 6/16 */);
            }
          }
          .pet3 {
            width: 5.1875/2*.74rem /* 83/16 */;
            height: 4.625/2*.74rem /* 74/16 */;
            &:active{
              transform: translateY(-.375rem /* 6/16 */);
            }
          }
          .pet4 {
            width: 7.1875/2*.74rem /* 115/16 */;
            height: 5.9375/2*.74rem /* 95/16 */;
            &:active{
              transform: translateY(-.375rem /* 6/16 */);
            }
          }
          .pet5 {
            width: 2.5/2*.74rem /* 40/16 */;
            height: 5.75/2*.74rem /* 92/16 */;
            &:active{
              transform: translateY(-.375rem /* 6/16 */);
            }
          }
          .pet6 {
            width: 6.25*.6*.6rem /* 100/16 */;
            height: 4.6875*.6*.6rem /* 75/16 */;
            &:active{
              transform: translateY(-.375rem /* 6/16 */);
            }
          }
          .pet7 {
            width: 5.6875*.6*.6rem /* 91/16 */;
            height: 5.875*.6*.6rem /* 94/16 */;
            &:active{
              transform: translateY(-.375rem /* 6/16 */);
            }
          }
          .pet8 {
            width: 5.9375*.6*.6rem /* 95/16 */;
            height: 6.125*.6*.6rem /* 98/16 */;
            &:active{
              transform: translateY(-.375rem /* 6/16 */);
            }
          }
          .pet9 {
            width: 5.8125*.6*.6rem /* 93/16 */;
            height: 3.9375*.6*.6rem /* 63/16 */;
            &:active{
              transform: translateY(-.375rem /* 6/16 */);
            }
          }
          .pet10 {
            width: 6.0625*.6*.6rem /* 97/16 */;
            height: 4.4375*.6*.6rem /* 71/16 */;
            &:active{
              transform: translateY(-.375rem /* 6/16 */);
            }
          }
        }
      }
      .content-couplet {
        display: flex;
        height: 100%;
        .cpItem {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 1;
          .hide {
            display: none;
            transition: all .4s ease;
          }
          .tutAgain {
            position: absolute;
            left: 3.125rem /* 50/16 */;
            top: .25rem /* 4/16 */;
            width: 4.6875rem /* 75/16 */;
            height: 2.9375rem /* 47/16 */;
            background-size: cover;
            background-repeat: no-repeat;
            background-image: url('./img/tut-again1.png');
            z-index: 3;
          }
          .tutAgain4 {
            position: absolute;
            right: 3.75rem /* 60/16 */;
            top: .25rem /* 4/16 */;
            width: 4.6875rem /* 75/16 */;
            height: 2.9375rem /* 47/16 */;
            background-size: cover;
            background-repeat: no-repeat;
            background-image: url('./img/tut-again2.png');
            z-index: 3;
          }
          .coup {
            width: 4.375*.8rem /* 70/16 */;
            height: 4.1875*.8rem /* 67/16 */;
            &:active{
              transform: translateY(-.375rem /* 6/16 */);
            }
          }
        }
      }
      .content-children {
        display: flex;
        height: 100%;
        .chItem {
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 1;
          .hide {
            display: none;
            transition: all .4s ease;
          }
          .child1 {
            width: 6.625/2*.62rem /* 106/16 */;
            height: 16.875/2*.62rem /* 270/16 */;
            &:active{
              transform: translateY(-.375rem /* 6/16 */);
            }
          }
          .child2 {
            width: 6.5/2*.62rem /* 104/16 */;
            height: 15.75/2*.62rem /* 252/16 */;
            &:active{
              transform: translateY(-.375rem /* 6/16 */);
            }
          }
          .child3 {
            width: 5.625/2*.8rem /* 90/16 */;
            height: 4.875/2*.8rem /* 78/16 */;
            &:active{
              transform: translateY(-.375rem /* 6/16 */);
            }
          }
          .child4 {
            width: 4.25/2*.8rem /* 68/16 */;
            height: 7.4375/2*.8rem /* 119/16 */;
            &:active{
              transform: translateY(-.375rem /* 6/16 */);
            }
          }
        }
      }
      .content-human {
        display: flex;
        height: 100%;
        .chItem {
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 1;
          .hide {
            display: none;
            transition: all .4s ease;
          }
          img {
            width: 60%*.65;
          }
        }
      }
      .content-detail {
        display: flex;
        height: 100%;
        .leftNav {
          flex: 0 0 20%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          .hide {
            display: none;
            transition: all .4s ease;
          }
          .hcSelected {
            background-color: #e0e0e0;
          }
          .head {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 50%;
            img {
              width: 50%*.65;
              // width: 2.125rem /* 34/16 */;
              // height: 2.25rem /* 36/16 */;
            }
          }
          .clothes {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 50%;
            img {
              width: 50%*.65;
              // width: 2.125rem /* 34/16 */;
              // height: 1.5625rem /* 25/16 */;
            }
          }
        }
        .rightDetail {
          height: 100%;
          width: 100%;
          .itemWrapper {
            width: 100%;
            height: 100%;
            .detailItemWrapper {
              flex: 1;
              display: flex;
              flex-wrap: wrap;
              height: 100%;
              width: 100%;
              .detailItem {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 33.3333%;
                img {
                  width: 40%*.65;
                  &:active{
                    transform: translateY(-.375rem /* 6/16 */);
                  }
                }
              }
              .halfDetailItem {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 50%;
                img {
                  width: 30%;
                  &:active{
                    transform: translateY(-.375rem /* 6/16 */);
                  }
                }
                .hide {
                  display: none;
                  transition: all .4s ease;
                }
              }
            }
          }
        }
      }
    }
  }
}

.hideContent {
  display: none;
}

.shine {
  animation: shine 1s ease-in 3;
  animation-fill-mode: both;
  animation-delay: .6s;
}

@keyframes shine {
  0%, 40% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.slideInOut {
  display: block;
  animation: slideInOut 4s ease-in-out;
  animation-fill-mode: both;
}

.hideIt {
  display: none;
}

@keyframes slideInOut {
  0%, 100% {
    opacity: 0;
  }
  10%, 90% {
    opacity: 1;
  }
}

.shake {
  animation: shake 1.6s ease-in-out infinite;
  animation-fill-mode: both;
}

@keyframes shake {
  from,
  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50% {
    -webkit-transform: translate3d(-2px, 0, 0);
    transform: translate3d(-2px, 0, 0);
  }

  20%,
  40%
  {
    -webkit-transform: translate3d(2px, 0, 0);
    transform: translate3d(2px, 0, 0);
  }
  51%, 100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

</style>
